export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_CLEAN = 'AUTH_CLEAN';
export const IS_AUTHENTICATED = 'IS_AUTHENTICATED';
export const M_UNAUTHORIZE = 'M_UNAUTHORIZE';
export const UNAUTHORIZE = 'UNAUTHORIZE';
export const POST_AUTHORIZATION = 'POST_AUTHORIZATION';
